// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"b226e589","187":"e5f8809b","453":"366359a2","796":"0f8b5dc3","906":"d7fda7e6"}[chunkId] + ".chunk.js";
};